import { OktaAuth } from '@okta/okta-auth-js'
import { getEnv } from '../config/OktaConfig';

export class OverviewHttpClient {

    constructor(private oktaAuth: OktaAuth) {}

    async request<T>(path: string, searchParams?: Map<string, string>, body?: unknown): Promise<T> {
        const accessToken = await this.oktaAuth.getAccessToken();
        const baseUrl = getEnv('REACT_APP_APPSYNC_LOCAL_CLEARANCE_HTTP_ENDPOINT') ?? 'https://dummygraphql.com';

        searchParams?.forEach((value, key) => {
            url.searchParams.append(key, encodeURIComponent(value));
        });
        
        const url = new URL(path, baseUrl);
        const response = await fetch(url.toString(), {
            method: !body ? 'GET' : 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: body ? JSON.stringify(body) : undefined
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        if(response.status === 204) {
            return {} as T;
        }
        
        return await response.json() as T;
    }
}